<template>
    <article class="Presenter" :style="[presenterPosition]">
        <video id="intro" ref="intro" :style="[scalePresenter]" v-if="hasIntroVideo" v-show="introPlaying" autoplay
            playsinline muted>
            <source :src="getMediaPath(properties.intro.mov.src)" type='video/mp4; codecs="hvc1"'>
            <source :src="getMediaPath(properties.intro.webm.src)" type="video/webm">
        </video>
        <video id="idle" ref="idle" :style="[scalePresenter]" v-show="!mainPlaying && !introPlaying && hasIdleVideo"
            :autoplay="!hasIntroVideo" playsinline muted loop>
            <source :src="getMediaPath(properties.idle.mov.src)" type='video/mp4; codecs="hvc1"'>
            <source :src="getMediaPath(properties.idle.webm.src)" type="video/webm">
        </video>
        <video id="main" ref="main" :style="[scalePresenter]" v-show="mainPlaying && !introPlaying && hasMainVideo"
            playsinline>
            <source :src="getMediaPath(properties.main.mov.src)" type='video/mp4; codecs="hvc1"'>
            <source :src="getMediaPath(properties.main.webm.src)" type="video/webm">
        </video>


        <button class="Hotspot defaultHotspot btnfx" :style="[hotspotPosition, { width: `${hotspotWidth}px` }]"
            @click="togglePlay" :class="{ 'defaultHotspot--flipped': properties.flipHotspot }" ref="hotspotButton">
            <div class="defaultHotspot__button btnfx__clicklight btnfx__hoverhalo"
                :class="{ 'defaultHotspot__button--skip': mainPlaying && !introPlaying }"></div>

            <div class="defaultHotspot__label" v-if="properties.hotspotTitle && !properties.hideHotspot"
                v-show="!(mainPlaying && !introPlaying)">
                <span v-html="properties.hotspotTitle"></span>
            </div>

        </button>
    </article>
</template>

<script>
export default {
    props: [
        "properties",
        "pageData"
    ],
    data() {
        return {
            videos: {},

            introPlaying: false,
            mainPlaying: false,
            hotspotWidth: null
        }
    },
    created() {
        this.introPlaying = this.hasIntroVideo ? true : false;
    },
    mounted() {
        this.videos = {
            intro: this.$refs.intro,
            idle: this.$refs.idle,
            main: this.$refs.main
        }

        this.events = {
            "introEnded": () => {
                this.videos.idle.currentTime = 0;
                this.videos.idle.play();
                this.introPlaying = false;
            },
            "ended": () => {
                this.mainPlaying = false;
                app.api.Tracking.event("Presenter", this.properties.hotspotTitle, "Watched")
            },

            "loadedmetadata": () => {
                this.$el.style.width = this.videos.idle.videoWidth + "px";
                this.$el.style.height = this.videos.idle.videoHeight + "px";
                // this.$el.style.width = this.videos.idle.videoWidth * this.properties.presenterSize + "px";
                // this.$el.style.height = this.videos.idle.videoHeight * this.properties.presenterSize + "px";
            }
        };

        if (this.videos.intro) {
            this.videos.intro.addEventListener("ended", this.events.introEnded)
        }
        if (this.videos.idle) {
            this.videos.idle.addEventListener("loadedmetadata", this.events.loadedmetadata)
        }
        if (this.videos.main) {
            this.videos.main.addEventListener("ended", this.events.ended)
        }

        window.addEventListener("presenterPlaying", e => {
            if (e.detail.presenterPlaying !== this.properties.hotspotTitle && !this.videos.main.paused) {
                this.skip();
            }
        });

        this.preloadMainVideo();
        this.hotspotWidth = this.$refs.hotspotButton.offsetWidth + 50;
    },
    beforeUnmount() {
        if (this.videos.intro) {
            this.videos.intro.removeEventListener("ended", this.events.introEnded)
        }
        this.videos.idle.removeEventListener("loadedmetadata", this.events.loadedmetadata)
        this.videos.main.removeEventListener("ended", this.events.ended)
        Object.values(this.videos).forEach(video => {
            if (video)
                video.pause();
        });
    },
    methods: {
        togglePlay() {
            if (this.mainPlaying && !this.introPlaying) {
                this.skip();
            } else {
                this.play();
            }
        },
        play() {
            let event = new CustomEvent('presenterPlaying', { detail: { presenterPlaying: this.properties.hotspotTitle } });
            window.dispatchEvent(event);
            this.videos.main.play();
            this.videos.idle.currentTime = 0;
            this.mainPlaying = true;
            app.api.Tracking.event("Presenter", this.properties.hotspotTitle, "Play")
        },
        skip() {
            this.videos.main.pause();
            this.videos.main.currentTime = 0;
            this.mainPlaying = false;
            app.api.Tracking.event("Presenter", this.properties.hotspotTitle, "Skip")
        },

        async preloadMainVideo() {
            if (!this.hasMainVideo)
                return


            var src = "";

            if (app.api.Utils.getBrowser == "Safari") {
                src = this.properties.main.mov.src
            } else {
                src = this.properties.main.webm.src
            }

            await app.api.Utils.preloadVideo(src);
        },
        getMediaPath(src) {
            return app.api.Utils.getMediaPath(src)
        }

    },
    computed: {
        scalePresenter() {
            return {
                transform: `scale(${this.properties.presenterSize})`
            }
        },
        presenterPosition() {
            return {
                left: this.properties.presenterPosition.xPosition + "px",
                top: this.properties.presenterPosition.yPosition + "px"
            }
        },
        hotspotPosition() {
            return {
                left: this.properties.hotspotPosition.xPosition + "px",
                top: this.properties.hotspotPosition.yPosition + "px"
            }
        },
        hasIntroVideo() {
            return !(this.properties.intro.mov === null || this.properties.intro.webm === null)
        },
        hasIdleVideo() {
            return !(this.properties.idle.mov === null || this.properties.idle.webm === null)
        },
        hasMainVideo() {
            return !(this.properties.main.mov === null || this.properties.main.webm === null)
        }
    }
};
</script>

<style lang="scss" scoped>
.Presenter {
    position: absolute;

    video {
        position: absolute;
        top: 0;
        left: 0;
    }

    .defaultHotspot {
        position: relative;
        z-index: 2;
        pointer-events: none;
        position: relative;

        &:focus {
                box-shadow:none!important;
            }


        * {
            pointer-events: all;
        }

        .defaultHotspot__button {
            background-size: 18px;
            background-image: url(@/assets/img/ui/play_dark.svg);
            background-position: 17px;
            transform: rotate(0deg) !important;
            justify-content: center;
            display: flex;
            align-items: center;
            height: 50px;
            color: var(--main-color);
            transition: all .3s var(--tk-easeinout);
            width: 50px;
            min-width: 50px;
            background-color: var(--main-color);
            background-clip: padding-box;
            border-radius: 50%;
            background-repeat: no-repeat;
            background-origin: content-box;
            border: 4px solid var(--main-color-transparent);
            border-radius: 50%;




            &--skip {
                background-image: url(@/assets/img/ui/close_dark.svg);
                background-size: 45%;
                background-position: center;
            }
        }

        .defaultHotspot__label {
           
            span {
                font-size: 20px;
                height: 50px;
                color:var(--dark-blue);
            }
        }
    }
}
</style>